import { useState, useEffect, useCallback } from "react";

interface UseFilterStateParams {
  searchData: (query: string) => void;
  clearSearch: () => void;
  storageKey?: string;
}

export const useFilterState = ({
  searchData,
  clearSearch,
  storageKey,
}: UseFilterStateParams) => {
  const [propertyFilter, setPropertyFilter] = useState(() =>
    storageKey ? localStorage.getItem(`${storageKey}_propertyFilter`) || "" : ""
  );
  const [roomFilter, setRoomFilter] = useState(() =>
    storageKey ? localStorage.getItem(`${storageKey}_roomFilter`) || "" : ""
  );
  const [lesseeFilter, setLesseeFilter] = useState(() =>
    storageKey ? localStorage.getItem(`${storageKey}_lesseeFilter`) || "" : ""
  );

  useEffect(() => {
    if (storageKey) localStorage.setItem(`${storageKey}_propertyFilter`, propertyFilter);
  }, [storageKey, propertyFilter]);

  useEffect(() => {
    if (storageKey) localStorage.setItem(`${storageKey}_roomFilter`, roomFilter);
  }, [storageKey, roomFilter]);

  useEffect(() => {
    if (storageKey) localStorage.setItem(`${storageKey}_lesseeFilter`, lesseeFilter);
  }, [storageKey, lesseeFilter]);

  const handleSearch = useCallback(() => {
    const query = [propertyFilter, roomFilter, lesseeFilter]
      .filter(Boolean)
      .join(" ")
      .trim();
    if (query) {
      searchData(query);
    } else {
      clearSearch();
    }
  }, [propertyFilter, roomFilter, lesseeFilter, searchData, clearSearch]);

  const handleClearSearch = useCallback(() => {
    setPropertyFilter("");
    setRoomFilter("");
    setLesseeFilter("");
    clearSearch();
  }, [clearSearch]);

  return {
    propertyFilter,
    setPropertyFilter,
    roomFilter,
    setRoomFilter,
    lesseeFilter,
    setLesseeFilter,
    handleSearch,
    handleClearSearch,
  };
};
